define((require) => {
    "use strict";

    const AbstractImageLibraryView = require("ui/imageLibrary/AbstractImageLibraryView");
    const DetailedImageLibraryCollectionView = require("ui/imageLibrary/DetailedImageLibraryCollectionView");

    /**
     *
     * @class DashboardImageLibraryView
     *
     */
    return AbstractImageLibraryView.extend("DashboardImageLibraryView", {

        imageLibraryClass: DetailedImageLibraryCollectionView,

        /**
         * Invoked from the dashboard view when the tab already exists and we just need to update partial views
         * Invokes update on `imageLibraryView`, see DetailedImageLibraryCollectionView#updatePartialViews
         */
        updatePartialViews(partialViewOptions) {
            this._imageLibraryView.updatePartialViews(partialViewOptions);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/imageLibrary/DashboardImageLibraryView.js